import { useEffect, useState } from 'react';
import axios from 'axios';
import { BASE_URL, Image_URL } from '../App';
import ReactConfetti from 'react-confetti';
import swal from 'sweetalert';
import { Container, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrophy, faGift, faCoins, faStar } from '@fortawesome/free-solid-svg-icons';
import '../styles/points.css';
import ScrollTopButton from './ScrollTop';
import AnimatedTrophy from './AnimatedTrophy';
import BrianAnimated from './BrainAnimated';
import StonesLoader from './Stones';
import SimpleLoader from './SimpleLoader';

function Points({ style, auth }) {
    const [levels, setLevels] = useState([]);
    const [rewards, setRewards] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [windowSize, setWindowSize] = useState({ width: window.innerWidth, height: window.innerHeight });
    const [activeTab, setActiveTab] = useState('online'); // 'online' or 'center'
    const [activeLevel, setActiveLevel] = useState(null);

    useEffect(() => {
        const handleResize = () => setWindowSize({ width: window.innerWidth, height: window.innerHeight });
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);
    
    useEffect(() => {
        window.scrollTo(0, 0);
        const fetchData = async () => {
            setIsLoading(true);
            const token = localStorage.getItem('token');
            const config = { headers: { 'Authorization': `Bearer ${token}` } };
             const delay = new Promise((resolve) => setTimeout(resolve, 2000)); 
            try {
 const [response] = await Promise.all([
                axios.get(`${BASE_URL}/api/market-info`, config),
                delay
            ]);                
                setLevels(response.data.data.levels || []);
                setRewards(response.data.data.points_rewards || []);
                
                // تحديد المستوى النشط بناءً على المستخدم
                if (auth && auth.id && auth.level) {
                    const userLevel = response.data.data.levels.find(level => level.level_id === auth.level);
                    if (userLevel) {
                        setActiveLevel(userLevel);
                    }
                } else if (response.data.data.levels.length > 0) {
                    setActiveLevel(response.data.data.levels[0]);
                }
            } catch (error) {
                console.error("Failed to fetch data:", error);
            } finally {
                setIsLoading(false);
            }
        };
        fetchData();
    }, []);

    // تم فصل رسالة الـ swal لتجنب إظهارها مع كل تغيير في auth
    useEffect(() => {
        if (!isLoading && auth && auth.id) {
            swal({
                title: 'نقاطك الحالية',
                text: `لديك ${auth.points} نقطة`,
                icon: 'info',
                button: 'تمام'
            });
        }
    }, [isLoading]);


    const handleRedeemReward = async (reward) => {
        if (!auth || !auth.id) {
            swal("خطأ", "يجب تسجيل الدخول أولاً", "error");
            return;
        }

        if (auth.points < reward.points) {
            swal("نقاط غير كافية", `تحتاج ${reward.points} نقطة، ولديك ${auth.points} نقطة فقط`, "warning");
            return;
        }

        swal({
            title: `هل تريد استبدال ${reward.points} نقطة بهذه الجائزة؟`,
            text: reward.title,
            icon: "warning",
            buttons: ["إلغاء", "نعم، استبدل"],
            dangerMode: true,
        }).then(async (willRedeem) => {
            if (willRedeem) {
                try {
                    const token = localStorage.getItem('token');
                    const config = { headers: { 'Authorization': `Bearer ${token}` } };
                    
                    await axios.post(`${BASE_URL}/api/request-user-reward`, {
                        reward_id: reward.id
                    }, config);
                    
                    swal("تم!", "تم إرسال طلبك بنجاح، سيتم التواصل معك قريباً.", "success");
                } catch (error) {
                    console.error('Error redeeming reward:', error);
                    swal("خطأ", "حدث خطأ أثناء إرسال الطلب، حاول مرة أخرى", "error");
                }
            }
        });
    };

    // تحديد البيانات المعروضة بناءً على المستوى النشط
    const getDisplayData = () => {
        if (!activeLevel) {
            return { online: [], center: [] };
        }

        return {
            online: activeLevel.online || [],
            center: activeLevel.center || []
        };
    };

    const displayData = getDisplayData();
    
    if (isLoading) {
        return (
            <div className={`main-loading ${style ? 'dark-mode' : ''}`}>
         <SimpleLoader size="large" />
         </div>
        );
    }

    return (
        <>
            <div className={`points-page ${style ? 'dark-mode' : ''}`}>
                <ReactConfetti width={windowSize.width} height={windowSize.height} numberOfPieces={450} gravity={0.03} recycle={true} />
                <Container>
                    {/* ===== بطاقة نقاط المستخدم (الجديدة) ===== */}
                    {auth && auth.id && (
                        <Row className="justify-content-center">
                            <Col lg={6} md={8}>
                                <div className="user-points-card">
                                    <FontAwesomeIcon icon={faStar} className="card-icon" />
                                    <div className="card-text">
                                        <h4>نقاطك الحالية</h4>
                                        <p>{auth.points} <span>نقطة</span></p>
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    )}

                    <div className="page-header points-header">
                        <AnimatedTrophy />
                        <h1>   أوائل المنصة  </h1>
                    </div>
                    
                    {/* اختيار المستوى الدراسي */}
                    {levels.length > 0 && (
                        <div className="level-selector">
                            {levels.map((level) => (
                                <button 
                                    key={level.level_id}
                                    className={`level-btn ${activeLevel?.level_id === level.level_id ? 'active' : ''}`}
                                    onClick={() => setActiveLevel(level)}
                                >
                                    {level.level_name}
                                </button>
                            ))}
                        </div>
                    )}
                    
                    {/* Tabs للتبديل بين الأونلاين والسنتر */}
                    <div className="leaderboard-tabs">
                        <button 
                            className={`tab-btn ${activeTab === 'online' ? 'active' : ''}`}
                            onClick={() => setActiveTab('online')}
                        >
                            الطلاب الأونلاين
                        </button>
                        <button 
                            className={`tab-btn ${activeTab === 'center' ? 'active' : ''}`}
                            onClick={() => setActiveTab('center')}
                        >
                            طلاب السنتر
                        </button>
                    </div>

                    <div className="leaderboard">
                        {activeTab === 'online' ? (
                            displayData.online.length > 0 ? (
                                displayData.online.map((user, index) => (
                                    <div className={`leaderboard-item rank-${index + 1}`} key={`online-${index}`}>
                                        <div className="rank-info">
                                            <span className="rank-number">{index + 1}</span>
                                            <div className="user-details">
                                                <h3 className="user-name">{user.fname + ' ' + user.lname}</h3>
                                                <span className="user-location">{user.government} - الصف {user.level === 2 ? 'الثاني' : 'الثالث'} الثانوي</span>
                                            </div>
                                        </div>
                                        <div className="points-info">
                                            <span>{user.points}</span> نقطة
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <div className="no-content-container">
                                    <h3>لا توجد بيانات متاحة</h3>
                                    <p>لم يتم تسجيل أي طالب أونلاين بعد</p>
                                </div>
                            )
                        ) : (
                            displayData.center.length > 0 ? (
                                displayData.center.map((user, index) => (
                                    <div className={`leaderboard-item rank-${index + 1}`} key={`center-${index}`}>
                                        <div className="rank-info">
                                            <span className="rank-number">{index + 1}</span>
                                            <div className="user-details">
                                                <h3 className="user-name">{user.fname + ' ' + user.lname}</h3>
                                                <span className="user-location">
                                                    {user.government && `${user.government} - `}
                                                    {auth?.center ? `سنتر ${auth.center}` : 'منصة'}
                                                    {user.level && ` - الصف ${user.level === 2 ? 'الثاني' : 'الثالث'} الثانوي`}
                                                </span>
                                            </div>
                                        </div>
                                        <div className="points-info">
                                            <span>{user.points}</span> نقطة
                                        </div>
                                    </div>
                                ))
                            ) : (
                                <div className="no-content-container">
                                    <h3>لا توجد بيانات متاحة</h3>
                                    <p>لم يتم تسجيل أي طالب في السنتر بعد</p>
                                </div>
                            )
                        )}
                    </div>

                    <div className="page-header rewards-header">
                        <FontAwesomeIcon icon={faGift} />
                        <h1>متجر الجوائز</h1>
                    </div>
                    <Row>
                        {rewards.length > 0 ? (
                            rewards.map((reward) => (
                                <Col lg={4} md={6} className="mb-4" key={reward.id}>
                                    <div className="reward-card">
                                        <div className="reward-image-wrapper">
                                            <img src={`${Image_URL}/storage/${reward.img}`} alt={reward.title} loading="lazy" />
                                            <div className="reward-points-tag">
                                                <FontAwesomeIcon icon={faCoins} />
                                                <span>{reward.points}</span>
                                            </div>
                                        </div>
                                        <div className="reward-content">
                                            <h4>{reward.title}</h4>
                                            <p>{reward.description}</p>
                                            <button className="redeem-btn" onClick={() => handleRedeemReward(reward)}>
                                                استبدل الجائزة
                                            </button>
                                        </div>
                                    </div>
                                </Col>
                            ))
                        ) : (
                            <Col xs={12}>
                               <div className="no-content-container">
  <div className="icon-wrapper-not">
    <span className="icon-line line-1"></span>
    <span className="icon-line line-2"></span>
  </div>
                           <h3>لا توجد جوائز متاحة حاليًا</h3>
                                    <p>جمع نقاط أكتر، قريبًا هنضيف جوايز جديدة!</p>
</div>
                                   
                            </Col>
                        )}
                    </Row>
                </Container>
            </div>
            <ScrollTopButton />
        </>
    );
}

export default Points;